<template>
  <section class="main">
    <div v-show="isLoading">
      <v-page-loading />
    </div>
    <div v-show="!isLoading">
      <div class="grid-container fluid" v-if="error">
        <div class="grid-x grid-margin-x align-center align-middle">
          <div class="cell small">
            <div class="callout alert text-center">{{ $t('projectmap.error.loading') }}</div>
          </div>
        </div>
      </div>
      <div class="c-project-map" v-else>
        <!-- Filter wrapper -->
        <div class="grid-container u-extra-small-margin--bottom">
          
          <div class="grid-x grid-margin-x align-middle">
            
            <!-- Project count -->
            <div class="cell small-auto medium-2">
              <p
                class="c-project-map__open-qm u-no-margin--bottom"
              >{{ $t('customers.projects_open') }}: {{ projectsCount }}</p>
            </div><!-- EO Project count -->
                        
            <!-- Filters -->
            <div class="cell small-auto medium-10">
              
              <div class="grid-container full">
                  <div class="grid-x grid-padding-x align-middle">
                                        
                    <div class="cell small-auto medium-3">
                        <div class="form-group form-group--row u-no-margin--bottom">
                          <label for="form-field-qmmin" class="u-no-margin--bottom text-right">{{ $t('search.from') }} </label>
                          <input
                            type="number"
                            inputmode="decimal"
                            v-model="filterQmMin"
                            id="form-field-qmmin"
                            name="qmmin"
                            placeholder="qm"
                            class="form-control form-control--small"
                          />
                           <label for="form-field-qmmax" class="u-no-margin--bottom text-right">{{ $t('search.till') }} </label>           
                            <input
                              type="number"
                              inputmode="decimal"
                              v-model="filterQmMax"
                              id="form-field-qmmax"
                              name="qmmax"
                              placeholder="qm"
                              class="form-control form-control--small"
                            />     
                       
                        </div>
                        
                    </div>
                 
                    <div class="cell small-auto medium-2">
                      
                        <button
                          class="button"
                          :title="$t('projectmap.label.filterqm')"
                          @click.prevent="filterSquareMeters"
                        >{{$t('projectmap.label.filterqm')}}</button>
                  
                    </div>
                    
                    <div class="cell small-auto medium-3">
                        
                        <v-project-map-asphalt-sort-filter
                            :filtered-projects="projects"
                            :resetLayerFilter="resetLayerFilter"
                            @selectedLayersChanged="populateMapWithFilterLayers"
                            @onResetDialogResults="onResetDialogResults"
                        >
                        </v-project-map-asphalt-sort-filter>
                        
                     </div> 
                    <div class="cell small-auto medium-2">
                      
                          <button
                            :title="$t('projectmap.label.resetmap')"
                            class="button"
                            @click.prevent="resetMap"
                          >{{ $t('projectmap.label.resetmap') }}</button>
                       
                      </div>
                    
                  </div> <!-- .grid-x grid-margin-x  -->
                  
                </div> <!-- .grid-container -->
          
               </div>  <!-- EO Filter wrapper -->
      
          </div><!-- .grid-x -->
          
        </div><!-- .grid-container -->  
        
        <div ref="projectmap" :id="'project-map-' + _uid" style="width: 100%; height: 100%"></div>
        <v-form-message
          type="error"
          id="form-error"
          :message="objectError"
          @onClickAction="onClickDialogAction"
        />
        
      </div><!-- .c-project-map -->
  
    </div><!-- EO v-show map content -->
    
   
    
  </section>
</template>

<script>
import PageLoading from "./../partials/PageLoading";
import gmapsInit from "../../geocoder/gmaps";
import FormMessage from "./../partials/Forms/FormMessage";
import ProjectMapAsphaltSortFilter from "./partials/ProjectMapAsphaltSortFilter";

export default {
  name: "ProjectMap",
  data: function () {
    return {
      filterQmMax: null,
      filterQmMin: null,
      filteredProjects: [],
      resetLayerFilter: false,
      zoom: 8,
      latlng: null,
      map: null,
      markers: [],
      pinNotAssigned: "/assets/img/leaflet/marker-icon-fill-red-small.svg",
      pinAssigned: "/assets/img/leaflet/marker-icon-fill-blue-small.svg",
      loading: false,
      projects: [],
      projectsCount: 0,
      error: false,
      objectError: null,
    };
  },

  async mounted() {
    try {
      this.getProjects();
      const google = await gmapsInit();
    } catch (e) {
      window.app.$helpers.logger(e);
    }
  },

  components: {
    vPageLoading: PageLoading,
    vFormMessage: FormMessage,
    vProjectMapAsphaltSortFilter: ProjectMapAsphaltSortFilter
  },

  computed: {
    isLoading: function () {
      return this.loading;
    },
    
  },
  
  methods: {

    onClickDialogAction: function () {
      this.objectError = null;
    },

    onResetDialogResults() {
      this.resetLayerFilter = false;
    },

    resetDialogResults () {
        this.resetLayerFilter = true;
    },

    /**
     * Populates our reactive array with all items that should be shown in the map.
     */
    populateMapWithFilterLayers (selectedLayerTypes) {
        let mapOutputItems = []; 
        selectedLayerTypes.forEach(layerType => {
            const foundProjects = this.filterLayers(layerType.name);
            if (foundProjects.length > 0) mapOutputItems.push(...foundProjects);
        });
        
        if (mapOutputItems.length > 0) {
            window.app.$helpers.logger('Populate map with filter layers => Found results: ' + mapOutputItems.length);
            this.filteredProjects = mapOutputItems;
            this.makeMap(this.filteredProjects);
            
        }else {
            window.app.$helpers.logger('Populate map with filter layers => No results found');
            if (selectedLayerTypes.length === 0 ) {
                this.filterSquareMeters();
            } 
        }
    },
    
    /**
     * 
     * @param {String} value the name of the layer to filter by the layer name
     * @returns: an array of mapOutputItem objects
     */
    filterLayers: function (value) {
        if (value == "") return;
        // Find all project items that contain at least one of the selected value
        let outputItems = this.projects.filter((project) => {
            if (project.lat !== null && project.lon !== null) {
                if (Object.keys(project.layers).length >= 1) {
                    for (const [key, val] of Object.entries(project.layers)) {
                        if (val.subtype === value) {
                            return true;
                        }
                    }
                }
            }
        });
        return outputItems;
    },


    /**
     * Filters the projects by square meters
     * when user clicks on the qm filter button
     */
    filterSquareMeters: function () {
        this.filteredProjects = this.projects;
        let min = this.filterQmMin;
        let max = this.filterQmMax;
        
        if (min === null) min = 0;
        if (max !== null) {
            window.app.$helpers.logger("Filter QM with max ..." + max);
        } else {
            window.app.$helpers.logger("Filter QM with no max. Min is: " + min);
        }
        
        window.app.$helpers.logger("Filter QM with these values: min: " + min + " and max:" + max);
        
       let filteredProjects = this.filteredProjects.filter(project => 
            min <= project.stats.qm.open && (max === null || project.stats.qm.open <= max)
        );
        
        if (filteredProjects.length > 0) {
            window.app.$helpers.logger("QM Filter found so many results: " + filteredProjects.length);
            this.filteredProjects = filteredProjects;
            this.makeMap(this.filteredProjects);
        } else {
            window.app.$helpers.logger("No QM Filter results found");
            this.makeMap(this.filteredProjects);
        }
    },
    
    
    /**
     * Map Settings
     *
     */
    resetMap: function () {
      this.makeMap(this.projects);
      this.filteredProjects = this.projects;
      this.resetDialogResults();
      this.filterQmMax = null;
      this.filterQmMin = null;
    },

    makeMap: function (items) {
      this.removeMap();
      window.app.$helpers.logger("Making map... ");

      const mapOptions = {
        center: new google.maps.LatLng(48.140499, 11.53506),
        zoom: this.zoom,
        disableDefaultUI: false,
        mapTypeId: "roadmap",
      };

      let bounds = new google.maps.LatLngBounds();
      this.map = new google.maps.Map(this.$refs.projectmap, mapOptions);
      this.map.setCenter(mapOptions.center);
      this.map.setZoom(mapOptions.zoom);

      if (items.length === 0) {
        window.app.$helpers.logger("No projects for the map. Exiting ...");
        this.error = true;
        return;
      }

      items.forEach((item) => {
        if (!item.lat && !item.lon) {
          window.app.$helpers.logger(
            "This project does not have geocoordinates ..." +
              item.project_number
          );
        } else {
          // Handle output of layers
          let layermarkup = "";
          if (item.layers.length >= 1) {
            item.layers.forEach((layer) => {
              let layeritem = `<li class="c-project-map-window__layer-item">${layer.subtype}</li>`;
              layermarkup = layermarkup + layeritem;
            });
          }

          // Handle output of tours
          let tourmarkup = "";
          if (item.tour_routes.length >= 1) {
            item.tour_routes.forEach((route) => {
              const startdate = this.$moment(route.tour_startdate).format(
                "DD.MM.YYYY"
              );
              const enddate = this.$moment(route.tour_enddate).format(
                "DD.MM.YYYY"
              );

              let touritem = `<div class="c-project-map-window__weekplan-entry">Kol.: ${route.kolonne}, von ${startdate} bis ${enddate}</div> `;
              tourmarkup = tourmarkup + touritem;
            });
          }

          // Handle output of weekday entries
          let weekplanmarkup = "";
          if (item.weekplan_entries.length >= 1) {
            item.weekplan_entries.forEach((plan) => {
              const startdate = this.$moment(plan.startdate).format(
                "DD.MM.YYYY"
              );
              let planitem = `<div class="c-project-map-window__weekplan-entry">Kol.: ${plan.kolonne}, ${startdate}</div> `;
              weekplanmarkup = weekplanmarkup + planitem;
            });
          }

          // Marker
          let pin = this.pinNotAssigned;

          if (
            item.weekplan_entries.length >= 1 ||
            item.tour_routes.length >= 1
          ) {
            pin = this.pinAssigned;
          }

          let position = new google.maps.LatLng(item.lat, item.lon);
          let marker = new google.maps.Marker({
            map: this.map,
            icon: pin,
            position: position,
          });

          this.markers.push(marker);
          bounds.extend(position);

          // Infobox
          let infocontent = `
            <div class="c-project-map-window">
            <p class="c-project-map-window__number u-extra-small-margin--bottom"><strong>${item.project_number}</strong></p>
            ${tourmarkup} ${weekplanmarkup}
            <p class="c-project-map-window__qm u-extra-small-margin--bottom">Offene m<sup>2</sup>: ${item.stats.qm.open}</p>
            <p class="c-project-map-window__address u-extra-small-margin--bottom"><strong>Kunde:</strong> ${item.customer.company_name}</p>
            <p class="c-project-map-window__address u-extra-small-margin--bottom">${item.address.street} ${item.address.housenumber} <br>
            <strong>${item.address.zipcode} ${item.address.city}</strong>
            </p>
            
            <ul class="c-project-map-window__layer-list">${layermarkup}</ul>
            <a href="${item.pageinfo.url}" class="button">Zum Auftrag</a>
            </div>
          `;
          google.maps.event.addListener(marker, "click", () => {
            let self = this;
            // check to see if a window already exits
            if (!self.infowindow) {
              self.infowindow = new google.maps.InfoWindow();
            }
            self.infowindow.setContent(infocontent);
            self.infowindow.open(this.map, marker);
          });
        }
      });
      window.app.$helpers.logger("Map is fitting bounds ...");

      this.map.fitBounds(bounds);

      //When we load the map by switching views in the app navigation, we get a zoom factor of 0. Do not know why.
      //To handle this, we check after the map is loaded, if we have a zoom factor 0, and if yes reset it to our global setting.
      const _vm = this;
      google.maps.event.addListenerOnce(_vm.map, "bounds_changed", function (
        event
      ) {
        window.app.$helpers.logger("Zoom Listener activated ...");
        let self = this;
        //window.app.$helpers.logger("Zoom ...", self.getZoom(), _vm.zoom);
        if (self.getZoom() === 0) {
          window.app.$helpers.logger(
            "Zoom adjusting...",
            self.getZoom(),
            _vm.zoom
          );
          self.setZoom(_vm.zoom);
        }
      });
    },

    removeMap: function () {
      this.map = null;
      this.markers = [];
    },

    getProjects: function () {
      window.app.$helpers.logger("Getting projects for the map...");
      this.loading = true;
      let promise = this.$api
        .clearParams()
        .addParam("ismap", true)
        .addParam("status", "open,busy")
        .get("projects");

      promise
        .then(
          ((response) => {
            this.projects = response.data.data;
            this.projectsCount = response.data.meta.pagination.total;

            this.error = false;
            this.makeMap(this.projects);
            this.filteredProjects = this.projects;

          }).bind(this)
        )
        .catch(
          ((error) => {
            window.app.$helpers.logger(
              "Error getting projects...",
              error.message
            );
            this.projects = [];
            this.projectsCount = 0;

            this.error = true;
          }).bind(this)
        )
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
